<template>
  <label class="a-checkbox__label" :style="{'margin-left': (40 * (category.level - 1)) + 'px'}">
    <input class="a-checkbox__input" type="checkbox" v-model="category.isMonitored" @change="onCategoryClick">
    <span class="a-checkbox__icon"></span>
    <span class="a-checkbox__text">
        {{category.name}}
    </span>
  </label>
</template>

<script>
  export default {
    props: {
      category: Object
    },

    methods: {
      async onCategoryClick() {
        this.$emit('click', this.category);
      }
    }
  }
</script>

<style scoped>

</style>
